<ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup"><p class="selection-title">
        {{ getText(question.globalizationConfig, "title") }}
    </p>
        <ion-input type="number" [placeholder]="getText(question.globalizationConfig, 'placeholder')"
                   [formControlName]="'field' + question.order + (isManagerComment ? 'Comment' : '')">
        </ion-input>
    </form>
</ng-container>